import env from './env';

const serverEnv = process.env.NODE_ENV;
const routes = env[serverEnv];

export {
  routes,
  serverEnv,
};
